import debounce from 'lodash/debounce';

export default class Sticky {
  constructor(elem, options) {
    let desktopWidth = 1024;
    this.element = elem;
    this.options = {
      offset: 0,
      ...options
    };

    this.clone = document.createElement('div');
    if (window.innerWidth < desktopWidth) {
      const elemH = this.element.offsetHeight;
      this.clone.style.height = `${elemH}px`;
      this.clone.classList.add('sticky-clone');
    }

    window.addEventListener('scroll', debounce(this.check, 10))

    this.check();
  }

  check = () => {
    // Add sticky class
    if (this.element.getBoundingClientRect().top <= (0 + this.options.offset)) {
      if (!this.isSticky()) {
        this.stick()
      }
    }

    if (this.isSticky()) {
      if (this.clone && this.clone.getBoundingClientRect().top > (0 + this.options.offset)) {
        this.unstick()
      }
    }
  }

  unstick = () => {
    if (this.isSticky()) {
      this.element.classList.remove('is-sticky');

      let stickyClone = document.querySelector('.sticky-clone');
      if (stickyClone !== null) {
        stickyClone.remove();
      }
    }
  }

  stick = () => {
    this.element.parentNode.prepend(this.clone);
    this.element.classList.add('is-sticky');
  }

  isSticky = () => {
    return this.element.classList.contains('is-sticky');
  }

  isInViewport = (elem) => {

    const elemRect = elem.getBoundingClientRect()
    const elemBot = elemRect.top + elemRect.height
    const winBot = window.scrollY + window.innerHeight
    return (
      !(
        elemBot < 0 || elem.offsetTop > winBot
      )
    );
  };
}
